import { connect } from 'react-redux';
import { setFormProcessing, addProductToBag, setLoading } from 'Favourites/store/actions';
import { LIST_TYPE } from 'Favourites/store/constants';

import { selectProducts } from 'Favourites/store/reducers/data/products';
import { selectIsFormProcessing } from 'Favourites/store/reducers';
import * as forms from 'Favourites/store/constants/formTypes';

const mapStateToProps = (state) => {
    return {
        products: selectProducts(state),
        processing: selectIsFormProcessing(state, forms.MovingProducts),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAllToBag: (products) => {
            const productList = [];
            for (const product in products) {
                if (products[product].onlineSellable) {
                    productList.push(
                        {
                            ItemType: { $: products[product].articleType },
                            ItemNo: { $: products[product].articleNumber.toString() },
                            ItemQty: { $: products[product].quantity },
                        }
                    );
                    dispatch(setLoading(products[product].articleNumber, true, LIST_TYPE));
                }
            }
            if (productList.length > 0) {
                dispatch(setFormProcessing('movingProducts', true));
                dispatch(addProductToBag(productList, LIST_TYPE, true));
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
